import React from "react";
import { Download } from "lucide-react";
import { PROFILE } from "../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#16281C] pt-16 pb-10 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <span className="font-display font-bold text-xl tracking-tight bg-[#2C5F3A] text-[#EFEBDE] w-11 h-11 flex items-center justify-center">
              AC
            </span>
            <p className="mt-6 font-display font-semibold text-2xl md:text-3xl tracking-tight text-[#EFEBDE] max-w-md leading-tight">
              {PROFILE.name}
            </p>
            <p className="mt-2 font-mono text-[11px] tracking-[0.2em] uppercase text-[#EFEBDE]/50">
              {PROFILE.title}
            </p>
            <a
              href={PROFILE.resumeUrl}
              download
              data-testid="footer-resume"
              className="mt-6 inline-flex items-center gap-2 border border-[#EFEBDE]/25 text-[#EFEBDE] font-mono text-[11px] tracking-[0.2em] uppercase px-5 py-3 hover:bg-[#2C5F3A] hover:border-[#2C5F3A] transition-colors"
            >
              <Download size={14} /> Download Résumé
            </a>
          </div>
          <div className="flex flex-col md:items-end gap-2 font-mono text-[11px] tracking-[0.15em] uppercase text-[#EFEBDE]/60">
            <a href={`mailto:${PROFILE.email}`} className="hover:text-[#EFEBDE] transition-colors">{PROFILE.email}</a>
            <a href={`tel:${PROFILE.phone.replace(/[^0-9]/g, "")}`} className="hover:text-[#EFEBDE] transition-colors">{PROFILE.phone}</a>
            <a href={PROFILE.permitflow} target="_blank" rel="noopener noreferrer" className="hover:text-[#EFEBDE] transition-colors">{PROFILE.permitflowLabel}</a>
            <a href={PROFILE.website} target="_blank" rel="noopener noreferrer" className="hover:text-[#EFEBDE] transition-colors">{PROFILE.websiteLabel}</a>
            <span className="text-[#EFEBDE]/50">{PROFILE.preconteam}</span>
            <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-[#EFEBDE] transition-colors">LinkedIn</a>
          </div>
        </div>

        <div className="mt-16 select-none">
          <p className="font-display font-bold uppercase text-[16vw] leading-[0.8] tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(239,235,222,0.25)]">
            CAMPOS
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-[#EFEBDE]/15 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-[#EFEBDE]/50">
          <span>© {new Date().getFullYear()} {PROFILE.name}. All rights reserved.</span>
          <span>Prosper, TX · Nationwide</span>
        </div>
      </div>
    </footer>
  );
};
